import React from "react";
import "../styles/components/PageLoader.css";

export const PageLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-ring"></div>
    </div>
  );
};
